import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60bdf706"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-fixed tw-bottom-0 tw-right-0 tw-z-10" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tw-mr-2" }
const _hoisted_4 = { class: "tw-flex tw-items-start" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-bg-white tw-absolute tw-bottom-0 tw-left-0 timed" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      "enter-active-class": "animate__animated animate__fadeInUp",
      "leave-active-class": "animate__animated animate__slideOutRight"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (not) => {
          return (_openBlock(), _createElementBlock("div", {
            key: not.messageId,
            onClick: ($event: any) => (_ctx.openNotification(not.data)),
            class: "tw-rounded tw-p-3 tw-mb-4 tw-mr-4 tw-shadow-md tw-flex tw-bg-gray-700 tw-text-white tw-border-l-4 tw-border-blue-500 tw-relative"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(not.data.notificationTitle), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => (_ctx.dimissNotification(not)), ["stop"])
              }, _hoisted_7, 8, _hoisted_5)
            ]),
            _hoisted_8
          ], 8, _hoisted_2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}